export const REPORT_TYPE: ReportType = {
  FOREGROUND: 'foreground',
  MOBILE: 'mobile',
  NETWORK: 'network',
  STORAGE: 'storage',
};

type ReportType = {
  FOREGROUND: string;
  MOBILE: string;
  NETWORK: string;
  STORAGE: string;
};
